exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CircularProgressbar .CircularProgressbar-path {\n  stroke: url(#GradientSvg) !important;\n}", ""]);

